<template>
  <div>
    <mbg-text-input v-model="search" :show-label="false" :title="$t('general.search')"  icon="icon-search"/>
    <div v-for="gate in filteredGates" :key="gate.gate" @click="selectGateFromList(gate)">
      <b-card class="my-2 cursor-pointer border-primary bg-light mb-2 shadow-none hover-brightness">

        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center gap-10">
            <div v-html="getIchingIcon(gate.gate_id)"/>

            <div>
              <h6>{{gate.gate_id}}. {{gate.name }}</h6>
              <label class="font-weight-light cursor-pointer"> {{gate.keynote }}</label>
            </div>

          </div>
          <div class="ml-auto">
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 13L7 7L0.999999 1" :stroke="darkMode ? '#fff' : '#191c23'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

      </b-card>

    </div>
  </div>


</template>

<script>
import {getIchingIcon} from "@/utils/iching";
import {localStorageKeys} from "@/utils/localStorage";
import MbgTextInput from "@/components/elements/MbgTextInput.vue";

export default{
  components: {MbgTextInput},
  props:{
    gates: Array,
    lines: Object,
  },
  data() {
    return {
      gateLineContents: {},
    }
  },
  watch: {
    lines(){
      this.prepareLineContentPerGate()
    }
  },
  computed: {
    search: {
      get() {
        return this.$store.state.ui.ichingSearch
      },
      set(val) {
        this.$store.commit('ui/SET_ICHING_SEARCH', val)
      }
    },
    filteredGates() {
      if (!this.search) return this.gates

      return this.gates.filter( gateContent => {
        const name = gateContent.gate_id + '. ' + gateContent.name.toLowerCase().trim();
        const description = gateContent.description.toLowerCase().trim();
        const keynote = gateContent.keynote.toLowerCase().trim();
        const cleanSearched = this.search.toLowerCase().trim();

        const lines = this.gateLineContents[gateContent.gate_id] || [];

        const hasLineExaltedOrDetrimentOrNameMatch = lines.some(line => {
          const lineName = line.name.toLowerCase().trim();
          const lineExaltedDescription = line.exalted_description.toLowerCase().trim();
          const lineDetrimentDescription = line.detriment_description.toLowerCase().trim();
          return lineName.includes(cleanSearched) || lineExaltedDescription.includes(cleanSearched)
              || lineDetrimentDescription.includes(cleanSearched) || lineName === cleanSearched;
        });

        return name.includes(cleanSearched) || keynote.includes(cleanSearched) || description.includes(cleanSearched) || hasLineExaltedOrDetrimentOrNameMatch
      });
    }
  },
  created() {
    this.prepareLineContentPerGate();
  },
  methods: {
    getIchingIcon,
    selectGateFromList(gate){
      const scrolledPos = document.getElementById('dictionary-side-panel-content').scrollTop;
      sessionStorage.setItem(localStorageKeys.ICHING_SCROLL_POSITION, scrolledPos.toString());
      this.$emit('gateClicked', gate)
    },

    prepareLineContentPerGate() {
      for (const [key, value] of Object.entries(this.lines)) {
        const [gateId, lineId] = key.split('.').map(Number);

        if (!this.gateLineContents[gateId]) this.gateLineContents[gateId] = [];

        if (this.gateLineContents[gateId].find(x => x.line_id === lineId && x.gate_id === gateId)) continue;

        this.gateLineContents[gateId].push(value);
      }
    }
  },
}
</script>